import { CampaignType } from 'types/campaign'
import { Action, Dispatch } from 'redux'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { db, FirebaseTimestamp } from 'firebase/index'
import { push } from 'connected-react-router'

const saveCampaign = (campaign: CampaignType) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())
    const now = FirebaseTimestamp.now()
    const ref = db.collection('campaigns').doc(campaign.campaign_id)
    const isExists = await ref.get().then((snapshot) => snapshot.exists)
    if (!isExists) {
      campaign.created_at = now
    }
    campaign.updated_at = now
    delete campaign.campaign_id
    return ref
      .set(campaign, { merge: true })
      .then(() => {
        dispatch(hideLoadingAction())
        dispatch(push(`/admin/campaign_cms/complete`))
      })
      .catch((error) => {
        dispatch(hideLoadingAction())
        console.error(error)
      })
  }
}

export default saveCampaign
